import { FeatureService } from './../../../../../core/services/feature/feature.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from "@angular/material/table";
import { Permission } from '../master-cliente-perfil-acesso.model';

@Component({
  selector: "cliente-table-perfil-acesso",
  templateUrl: "./cliente-table-perfil-acesso.component.html",
  styleUrls:['./cliente-table-perfil-acesso.component.scss']

})
export class ClienteTablePerfilAcesso implements OnInit {
  maxItems = 8;
  permissions: MatTableDataSource<Permission>;
  selection = new SelectionModel<Element>(true, []);
  allComplete: boolean = false

  @ViewChild('sort', {static: false}) sort: MatSort;
  @Input() dataPermissions: Array<any>
  @Input() filterPermissions: EventEmitter<any>;
  @Input() idCheckboxHeader: number;

  @ViewChild('profilePermissions', {static: false}) profilePermissions: any;

  @Output() filterProfile: EventEmitter<any> = new EventEmitter<any>();
  permissionFilter: any;
  filterAutoComplete: any;

  permissionList: Permission[];
  constructor(private featureService:FeatureService){}
  ngOnInit() {
    this.getPermissionsInitialSorted();
  }

  ngAfterViewInit (){
    this.getPermissionsInitialSorted();
  }

  getPermissionsInitialSorted(){
    this.dataPermissions.forEach(element=>{
      element.name = this.featureService.translatorService.translateEnumItem(element.name,'PermissionsType')
    })
    this.dataPermissions.sort((a, b) =>
    a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
  )
    const checked = this.dataPermissions.filter((row) => row.checked == true);
    const unChecked = this.dataPermissions.filter((row) => row.checked == false || row.checked == undefined);
    this.permissions = new MatTableDataSource([].concat(...checked, ...unChecked));
    this.permissions.sort = this.sort;
    this.permissionList = this.permissions.data;
    this.isAllSelected()
  }
  
  getPermissionsDataSorted(){
    return this.dataPermissions.sort((a, b)=> {
      if (a.name === null) a.name = '';
      if (b.name === null) b.name = '';
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      return 0;
    });
  }

  getPermissionsSorted(){
    this.permissions = new MatTableDataSource(this.getPermissionsDataSorted());
    this.permissions.sort = this.sort;
    this.permissionList = this.permissions.data;
    this.isAllSelected()
  }

  filterPermissionsInput(event) {

    this.permissions.filterPredicate = (data, filter) => {
      data.name = this.featureService.translatorService.translateEnumItem(data.name,'PermissionsType')
      return data.name.toLowerCase().includes(filter.toLowerCase()) || data.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
    }

    this.permissionFilter = (event.target as HTMLInputElement).value;
   
    if (this.permissionFilter.length == 1 || this.permissionFilter.length > 0 ){
      this.permissions.filter = this.permissionFilter
      this.filterAutoComplete =  this.permissions.filteredData.sort((a,b) => a.name > b.name ? 1 : -1)
    } else if (this.permissionFilter.length == 0) {
      this.permissions.filter = this.permissionFilter
      this.filterAutoComplete = []
    }
  }

  toogleAllSelected() {
    this.allComplete = !this.allComplete;
    this.permissions.data.forEach((row)=> row.checked = this.allComplete )
  }

  isAllSelected() {
    this.allComplete = this.permissions.data.every((row) => row.checked == true );
  }

  hasSomeSelected() {
    return this.permissions.data.some((row) => row.checked == true );
  }

  toggleSelection(row){
    this.permissions.data.forEach((data)=> {
      if(row.id === data.id){
        row.checked = !row.checked;
      }
    })
    this.isAllSelected()
  }
}
